import { isInactive, isActive, isPending } from '@utils/hotelPriceRulesUtils';
import { compareFNSortByExpireAndActivate } from '@utils/hotelPriceRulesUtils';
import factory from '@helpers/storeFactories/factory';
import { apiServicePriceRules } from '@api';
import hotelPriceRulesLookup from './hotelPriceRulesLookup';
import { normalizeHotelPriceRule } from '@/utils/storeDataNormalization';
import storeConstants from '@/utils/constants/store';
import { mutationTypes } from '@/helpers/storeFactories';
import notificationUtils from '@/utils/notificationUtils';

const STORE_NAME = 'hotelPriceRules';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServicePriceRules.priceRules.hotel.get,
        one: apiServicePriceRules.priceRules.hotel.one,
        create: apiServicePriceRules.priceRules.hotel.create,
        update: apiServicePriceRules.priceRules.hotel.update,
    },
    {
        actions: {
            create: true,
            update: true,
            delete: true,
            select: true,
        },
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 99,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalizeHotelPriceRule,
    },
    {
        getters: {
            canActivateAllSelected: (state, getters) => () => {
                return !!getters.getAllSelected().find(isInactive);
            },
            canDeactivateSelected: (state, getters) => () => {
                return !!getters.getAllSelected().find((item) => {
                    return isActive(item) || isPending(item);
                });
            },
            isMultiSelected: (state, getters) => () => {
                return getters.getAllSelected().length > 1;
            },
        },
        mutations: {
            sortDefault: (state) => {
                state.list.sort(compareFNSortByExpireAndActivate);
            },
        },
        actions: {
            async update({ commit, state, dispatch }, { id, data, silent }) {
                const response = await apiServicePriceRules.priceRules.hotel.update(id, data);

                if (!response.success) {
                    silent &&
                        dispatch(
                            'notification/error',
                            notificationUtils.getFromApiResponse(response),
                            { root: true }
                        );

                    return response;
                } else {
                    const responseData = response.data;

                    if (responseData.id != id) {
                        dispatch('reload');
                        return {
                            success: true,
                            data: response.data,
                        };
                    } else {
                        commit(mutationTypes.CREATE_OR_UPDATE_ITEM, {
                            id: responseData.id,
                            data: responseData,
                        });
                        return {
                            success: true,
                            data: state.listMap[responseData.id],
                        };
                    }
                }
            },
            async activate({ commit, getters, dispatch }, data) {
                const response = await apiServicePriceRules.priceRules.hotel.activate(
                    getters
                        .getAllSelected()
                        .map((item) => item.id)
                        .pop(),
                    data
                );

                if (response.success) {
                    dispatch('deselectAllItems');
                    commit(mutationTypes.UPDATE_ITEM, {
                        id: response.data.id,
                        data: response.data,
                    });
                }
                return response;
            },
            async deactivate({ commit, getters }) {
                const response = await apiServicePriceRules.priceRules.hotel.deactivate(
                    getters
                        .getAllSelected()
                        .map((item) => item.id)
                        .pop()
                );
                if (response.success) {
                    commit(mutationTypes.UPDATE_ITEM, {
                        id: response.data.id,
                        data: response.data,
                    });
                }

                return response;
            },
            sortDefault({ commit }) {
                commit('sortDefault');
            },
        },
        modules: {
            lookup: hotelPriceRulesLookup,
        },
    }
);

export default store;
